export const cities = [
        {
          value: "AME",
          title: "Americana",
          pdfPath: 'estapar'
        },
        {
          value: "ARA",
          title: "Araraquara",
          pdfPath: 'estapar'
        },
        {
          value: "BHZ",
          title: "Belo Horizonte",
          pdfPath: 'bhz'
        },
        {
          value: "CJZ",
          title: "Cajazeiras",
          pdfPath: 'cjz'
        },
        {
          value: "CWB",
          title: "Curitiba",
          pdfPath: 'cwb'
        },
        {
          value: "FTZ",
          title: "Fortaleza",
          pdfPath: 'ftz'
        },
        {
          value: "ITA",
          title: "Itatiba",
          pdfPath: 'estapar'
        },
        {
          value: "JAC",
          title: "Jacareí",
          pdfPath: 'estapar'
        },
        {
          value: "JDN",
          title: "Juazeiro do Norte",
          pdfPath: 'jdn'
        },
        {
          value: "JZF",
          title: "Juiz de Fora",
          pdfPath: 'estapar'
        },
        {
          value: "LIM",
          title: "Limeira",
          pdfPath: 'estapar'
        },
        {
          value: "MOG",
          title: "Mogi das Cruzes",
          pdfPath: 'estapar'
        },
        {
          value: "MON",
          title: "Mongaguá",
          pdfPath: 'mon'
        },
        {
          value: "RIC",
          title: "Rio Claro",
          pdfPath: 'estapar'
        },
        {
          value: "SGR",
          title: "Salgueiro",
          pdfPath: 'sgr'
        },
        {
          value: "SSA",
          title: "Salvador",
          pdfPath: 'ssa'
        },
        {
          value: "SBO",
          title: "Santa Bárbara D'Oeste",
          pdfPath: 'estapar'
        },
        {
          value: "STA",
          title: "Santo André",
          pdfPath: 'estapar'
        },
        {
          value: "SBC",
          title: "São Bernardo do Campo",
          pdfPath: 'estapar'
        },
        {
          value: "SCA",
          title: "São Carlos",
          pdfPath: 'estapar'
        },
        {
          value: "SSG",
          title: "São Gabriel",
          pdfPath: 'estapar'
        },
        {
          value: "SBV",
          title: "São João da Boa Vista",
          pdfPath: 'estapar'
        },
        {
          value: "SAO",
          title: "São Paulo",
          pdfPath: 'sao'
        },
        {
          value: "TAU",
          title: "Taubaté",
          pdfPath: 'estapar'
        }
  ];
  
  export function getCityName(cityValue) {
    let city = cities.find(c => c.value === cityValue);
    return city ? city.title : cityValue;
  }
  